import React from 'react';
import ScriptAutomationPanel from '../components/panels/ScriptAutomationPanel';

const LAUNCH_ENDPOINTS = {
  maps_profile: '/api/gmail-scripts/maps-review',
};

const GoogleMapsAutomation = ({ selectedDevice }) => (
  <ScriptAutomationPanel
    title="Google Maps — Automatisation"
    scriptsEndpoint="/api/google-scripts/available?category=maps"
    launchEndpoints={LAUNCH_ENDPOINTS}
    selectedDevice={selectedDevice}
  />
);

export default GoogleMapsAutomation;
